var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"site_footer"},[_c('p',{staticClass:"site_footer__copy"},[_vm._v("© Social Insurance Advisers Association.")])])}]

export { render, staticRenderFns }